module.exports = __webpack_public_path__ + "img/serifnew_box21.071c90ac.jpg";